module.exports = __webpack_public_path__ + "img/download-cloud.8484153d.svg";